export default {"src":"/_next/static/media/image_home.0dab6a97.svg","height":270,"width":257,"blurWidth":0,"blurHeight":0};